/**
 * Base theme — the canonical/default LMS look, alias
 * {@code corporateClassicTheme}. Restrained indigo brand on slate
 * neutrals, Inter / Inter Tight type, 8px radii, soft shadows. The
 * all-purpose corporate aesthetic that works for SaaS academies,
 * internal training, and partner portals.
 *
 * <p>Empty overrides — the resolver falls back to {@code defaultBlocks}
 * (genericBlocks) for every block type, which IS the base look
 * (styled by the tokens at the CSS-variable layer). Other theme
 * packages inherit from this when they don't override a given block /
 * system / primitive.
 *
 * <p>{@code standardTheme} is a legacy alias kept resolvable for
 * older imports.
 */
import type { ThemeBundle } from '../portal';

export const baseTheme: ThemeBundle = {
  blocks: {},
  system: {},
};

export const standardTheme = baseTheme;
